import React,{useState, useEffect} from 'react'
import TableHeading from "../../Components/common/table/Tableheading";
import { showData } from "../../Utils/APIs/commonShowAPI";

const InstalledList = () => {
  const [insuranceList, setInsuranceList] = useState([]);
  const heading = [
    "Sr. No",
    "Farmer Name",
    "Saral ID",
    "Farmer Mobile",
    "State",
    "status",
    "Complaint Details",
    "Resolve Date"
  ];

   useEffect(() => {
      const fetchData = async () => {
        await showData(`/insurance/installedList`, setInsuranceList);
      };
      fetchData();
    }, []);
    
  return (
    <div className="h-full flex flex-col overflow-auto">
      <div>
        <h1 className="text-3xl font-semibold tracking-widest text-center p-2 bg-gray-50 rounded-lg">
          I<span className="text-lg">NSTALLED</span> L
          <span className="text-lg">IST</span>
        </h1>
      </div>

      <div className="relative *:overflow-x-auto shadow-md sm:rounded-lg m-4 z-5">
        <table className="relative w-full text-sm text-gray-500 text-center">
          <TableHeading list={heading} />
          <tbody className="bg-white divide-y divide-gray-200">
            {insuranceList && insuranceList.length > 0 ? (
              insuranceList.map((item, index) => (
                <tr
                  key={item?._id}
                  className="hover:bg-gray-100"
                >
                  <td className="px-6 py-4 whitespace-nowrap">{index + 1}</td>
                  <td className="px-6 py-4 whitespace-nowrap">{item?.farmerId?.farmerName}</td>
                  <td className="px-6 py-4 whitespace-nowrap">{item?.farmerId?.saralId}</td>
                  <td className="px-6 py-4 whitespace-nowrap">{item?.contact || item?.farmerId?.contact}</td>
                  <td className="px-6 py-4 whitespace-nowrap">{item?.farmerId?.state}</td>
                  <td className="px-6 py-4 whitespace-nowrap">{item?.stage?.stage}</td>
                  <td className="px-6 py-4 whitespace-nowrap">{item?.complaintDetails}</td>
                  <td className="px-6 py-4 whitespace-nowrap">{item?.updated_At.toString().split('T')[0]}</td>
                </tr>
              ))): (
                <tr>
                  <td colSpan={heading.length} className="text-center p-4">
                    No data available
                  </td>
                </tr>
              )
            }
          </tbody>
        </table>
      </div>
    </div>

  )
}

export default InstalledList